import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { Routes, RouterModule } from '@angular/router'

import { IonicModule } from '@ionic/angular'

import { DashboardPage } from './dashboard.page'

const routes: Routes = [
  {
    path: '',
    component: DashboardPage,
    children: [
      { path: 'event', loadChildren: '../event/event.module#EventPageModule' },
      // { path: 'group', loadChildren: '../group/group.module#GroupPageModule' },
      { path: 'my-plan', loadChildren: '../my-plan/my-plan.module#MyPlanPageModule' },
      { path: 'invitation', loadChildren: '../invitation/invitation.module#InvitationPageModule' },
      // { path: 'profile', loadChildren: '../profile/profile.module#ProfilePageModule' },
      { path: '', redirectTo: 'event', pathMatch: 'full' },
    ]
  }
]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [DashboardPage]
})
export class DashboardPageModule { }
